<template>
  <div class="container-fluid">
    <div id="printableArea" class="card">
      <div class="card-body">
      <div class="row" style="margin-top: 20px">
        <table>
          <tbody>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Status
            </td>
            <td style="font-size: medium">
              {{ audit.status }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Certification
            </td>
            <td style="font-size: medium">
              {{ audit.certification_name }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Auditor
            </td>
            <td style="font-size: medium" v-if="audit">
              {{ audit.auditors }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Audit Creator
            </td>
            <td style="font-size: medium" v-if="audit">
              {{ audit && audit.audit_creator }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Organization Name
            </td>
            <td style="font-size: medium">
              {{ cluster.org_name }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Organization ID
            </td>
            <td style="font-size: medium">
              {{ cluster.org_id }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Entity Name
            </td>
            <td style="font-size: medium">
              {{ cluster.entity_name }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Address
            </td>
            <td style="font-size: medium">
              {{ cluster.address }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Contact Person
            </td>
            <td style="font-size: medium">
              {{ cluster.contact_person }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Email
            </td>
            <td style="font-size: medium">
              {{ cluster.email }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Phone No
            </td>
            <td style="font-size: medium">
              {{ cluster.phone_num }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Certifier Reference ID
            </td>
            <td style="font-size: medium">
              {{ cluster.cert_ref_id }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Assessment Start Date
            </td>
            <td style="font-size: medium">
              {{ cluster.assessment_start_date }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Assessment End Date
            </td>
            <td style="font-size: medium">
              {{ cluster.assessment_end_date }}
            </td>
          </tr>
          <tr>
            <td style="font-weight: bold; font-size: medium">
              Coordinate
            </td>
            <td style="font-size: medium">
              {{ cluster.geo_coordinates }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row" style="margin-top: 40px">
              <div class="tab-content tabcontent-border p-t-40 ">
                <div class="tab-pane active show" id="notes" role="tabpanel" v-if="audit.auditor_notes">
                  <h3>Audit Notes</h3>
                  <div v-html="audit.auditor_notes"/>
                </div>
                <div :key="impactArea.abbreviation" class="tab-pane active show"
                     role="tabpanel" v-for="impactArea in audit.impact_areas">
                  <impact-area :audit-id="auditId" :audit-status="audit.status"
                               :auditor="auditor" :certification-id="impactArea.certification"
                               :impact-area="impactArea"/>
                </div>
              </div>
      </div>
      <div id="editor"/>
      </div>
    </div>
  </div>
</template>

<script>
  import EventBus from '../../../../event-bus';
  import ImpactArea from './ImpactArea.vue';

  export default {
    name: 'PrintAuditTemplate',
    components: {ImpactArea},
    props: ['auditId', 'audit', 'events', 'auditor'],
    data() {
      return {
        activeTab: 'notes',
        cluster: {
          org_name: '',
          org_id: '',
          entity_name: '',
          address: '',
          contact_person: '',
          email: null,
          phone_num: '',
          cert_ref_id: '',
          assessment_start_date: null,
          assessment_end_date: null,
          geo_coordinates: null
        }
      };
    },
    mounted() {
      this.getCluster();
      EventBus.$on('printDiv', () => {
        this.printDiv();
      });
    },
    methods: {
      async getCluster() {
        try {
          const {data} = await this.$api.get(`/audits/${this.auditId}/clusters`);
          if (data) {
            this.cluster = data;
          }
        } catch (e) {
          console.error(e);
        }
      },
      printDiv() {
        if (this.audit) {
          var sTable = document.getElementById('printableArea').innerHTML;

          var style = '<style>';
          style = style + 'table {width: 100%;font-size: 10px;}';
          style = style + 'table, th, td {border: solid 1px #DDD; border-collapse: collapse;';
          style = style + 'padding: 2px 3px;text-align: justify;}';
          style = style + 'table td:nth-child(3),td:nth-child(5) {width:30%}';
          style = style + 'table th {text-align: center}';
          style = style + 'h4, p {font-size: 12px;}';
          style = style + '</style>';

          // CREATE A WINDOW OBJECT.
          const title = `Audit-${this.auditId}`;
          window.document.write('<html><head>');
          window.document.write(`<title>${title}</title>`); // <title> FOR PDF HEADER.
          window.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
          window.document.write('</head>');
          window.document.write('<body>');
          window.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
          window.document.write('</body></html>');

          window.print();
          this.$router.go();
        }
      }
    }
  }
</script>

<style scoped>
  @media print{
    body, html, #page-container, .scrollable-page, .ps, .panel {
      height: 100% !important;
      width: 100% !important;
      display: inline-block;
    }
  }
</style>
